






import { Component, Vue, Prop } from 'vue-property-decorator'
import { NightAction } from '@/class/game'
import { MASTER_ROLE } from '@/class/const'
import { RoleId } from '@/enum'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Card
  }
})
export default class NightActionResultCards extends Vue {
  @Prop() nightAction!: NightAction
  @Prop() playerId!: string

  get showRoleIds () {
    const showRoleIds: RoleId[] = []

    const player = this.afterPlayerOf[this.playerId]

    if (!player) {
      return []
    }

    if (player.deathDetails) {
      return showRoleIds
    }

    if (player.status.eatCrab) {
      showRoleIds.push(RoleId.crab)
      return showRoleIds
    }

    if (player.status.tempted) {
      showRoleIds.push(RoleId.dancer, RoleId.prostitute)
      return showRoleIds
    }

    if (player.status.stolen && MASTER_ROLE[player.roleId].weapon) {
      showRoleIds.push(RoleId.pickpocket)
      return showRoleIds
    }

    return showRoleIds
  }

  get afterPlayerOf() {
    return this.nightAction.playLogs.length ? this.nightAction.playLogs[this.nightAction.playLogs.length - 1].afterPlayers : {}
  }
}
